<template>
  <div class="movie-home-slider-area">
    <Swiper
      :slidesPerView="1"
      :loop="true"
      :effect="'fade'"
      :speed="1000"
      :autoHeight="true"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: false,
      }"
      :navigation="{
        nextEl: '.button-next',
        prevEl: '.button-prev',
      }"
      :pagination="{
        el: '.movie-home-slider-pagination',
        clickable: true,
      }"
      :modules="modules"
      class="movie-home-slider"
    >
      <SwiperSlide v-for="(slide, index) in slides" :key="index">
        <div
          class="movie-home-slider-item"
          :style="{ backgroundImage: `url(${slide.image})` }"
        >
          <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-6 col-md-12">
                <!-- تم إضافة تنسيق الاتجاه العربي هنا لجمالية المظهر -->
                <div class="movie-home-slider-content" style="text-align: right; direction: rtl;" data-cue="slideInLeft">
                  <ul class="meta" style="display: flex; gap: 10px; padding: 0; list-style: none; flex-wrap: wrap;">
                    <li v-for="(category, i) in slide.categories" :key="i" style="white-space: nowrap;">
                      <RouterLink to="/channel-list">{{ category }}</RouterLink>
                    </li>
                  </ul>
                  <h1 style="line-height: 1.3; font-size: 2.8rem; max-width: 100%;">{{ slide.title }}</h1>
                  <p>
                    {{ slide.description }}
                    <RouterLink to="/services-details">اقرأ المزيد</RouterLink>
                  </p>
                  <div class="rating-and-clock" style="display: flex; align-items: center; gap: 15px;">
                    <ul class="rating" style="display: flex; padding: 0; list-style: none;">
                      <li v-for="star in 5" :key="star">
                        <i class="ri-star-fill"></i>
                      </li>
                      <li>
                        <span>{{ slide.rating }}</span>
                      </li>
                    </ul>
                    <div class="clock" style="display: flex; align-items: center; gap: 5px;">
                      <img
                        src="@/assets/images/movie-home/clock.svg"
                        alt="clock"
                      />
                      <span>{{ slide.duration }}</span>
                    </div>
                  </div>
                  <ul class="btn-list" style="display: flex; gap: 15px; padding: 0; list-style: none;">
                    <li>
                      <!-- رابط واتساب مباشر للاشتراك -->
                      <a href="https://wa.me/447429916178" target="_blank" class="btn">
                        <span class="border-style">اشترك الآن</span>
                      </a>
                    </li>
                    <li>
                      <!-- رابط واتساب مباشر للتجربة -->
                      <a href="https://wa.me/447429916178" target="_blank" class="btn">
                        <span class="border-style">تجربة مجانية</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-lg-6 col-md-12">
                <div class="movie-home-slider-video-btn">
                  <lightgallery :settings="{ speed: 500, plugins }">
                    <a :href="slide.trailerUrl" class="video-btn">
                      <i class="ri-play-fill"></i>
                    </a>
                  </lightgallery>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>

      <ul class="movie-home-slider-button" style="display: flex; gap: 10px; list-style: none;">
        <li>
          <div class="button-prev">
            <img src="@/assets/images/movie-home/arrow1.svg" alt="arrow1" />
          </div>
        </li>
        <li>
          <div class="button-next">
            <img src="@/assets/images/movie-home/arrow2.svg" alt="arrow2" />
          </div>
        </li>
      </ul>

      <div class="movie-home-slider-pagination"></div>
    </Swiper>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";

import Lightgallery from "lightgallery/vue";
import lgVideo from "lightgallery/plugins/video";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";

export default defineComponent({
  name: "MainBanner",
  components: {
    Swiper,
    SwiperSlide,
    Lightgallery,
  },
  setup() {
    const plugins = ref([lgVideo]);

    /* eslint-disable @typescript-eslint/no-var-requires */
    const slides = ref([
      {
        title: "أفضل اشتراك قنوات عربية وعالمية IPTV",
        description:
          "استمتع بمشاهدة كافة القنوات الرياضية والترفيهية المفضلة لديك مع سيرفر loay iptv. نوفر لك بثاً مباشراً عالي الجودة يضم أضخم باقات القنوات المشفرة وبأعلى ثبات ممكن.",
        image: require("@/assets/images/movie-home/slider-bg1.jpg"),
        categories: ["قنوات عربية", "بث مباشر 4K", "ثبات فائق"],
        rating: "5.0",
        duration: "تحديث يومي",
        trailerUrl: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        title: "شاهد جميع المباريات والبطولات العالمية حصرياً",
        description:
          "لا تفوت أي مباراة بعد الآن! تابع أقوى الدوريات والبطولات الرياضية العالمية بجودة فائقة وبدون أي تقطيع في البث. مكتبة متجددة من أحدث الأفلام والمسلسلات بانتظارك.",
        image: require("@/assets/images/movie-home/slider-bg2.jpg"),
        categories: ["باقات رياضية", "مكتبة أفلام VOD", "دعم 24/7"],
        rating: "4.9",
        duration: "سيرفرات فائقة",
        trailerUrl: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        title: "أضخم مكتبة أفلام ومسلسلات متجددة باستمرار",
        description:
          "تابع أحدث الإنتاجات العربية والعالمية، الحصريات، ومنصات البث الشهيرة في مكان واحد وبجودة عالية تناسب جميع سرعات الإنترنت ومختلف أجهزتك الذكية.",
        image: require("@/assets/images/movie-home/slider-bg3.jpg"),
        categories: ["أحدث الأفلام", "مسلسلات حصريّة", "منصات بث"],
        rating: "4.8",
        duration: "تحديثات فورية",
        trailerUrl: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
    ]);
    /* eslint-enable @typescript-eslint/no-var-requires */

    return {
      modules: [Autoplay, Navigation, Pagination, EffectFade],
      slides,
      plugins,
    };
  },
});
</script>